import { render, staticRenderFns } from "./single-work-vitaminsea.vue?vue&type=template&id=6af6c789&scoped=true&lang=pug&"
import script from "./single-work-vitaminsea.vue?vue&type=script&lang=js&"
export * from "./single-work-vitaminsea.vue?vue&type=script&lang=js&"
import style0 from "./single-work-vitaminsea.vue?vue&type=style&index=0&id=6af6c789&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af6c789",
  null
  
)

export default component.exports